// QuestionVideoURL.js
import React from "react";
import { QuestionTextModel, QuestionFactory, Serializer } from "survey-core";
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from "survey-react-ui";

const QUESTION_TYPE = "videourl";

/* =========================================================
   QUESTION MODEL - Simple
========================================================= */
class QuestionVideoURLModel extends QuestionTextModel {
  constructor(name) {
    super(name);
    this.inputType = "url";
    this.placeholder = "Enter video URL";
  }

  getType() {
    return QUESTION_TYPE;
  }
}

/* =========================================================
   REACT RENDERER - Fixed
========================================================= */
class SurveyQuestionVideoURL extends SurveyQuestionElementBase {
  // FIX: Use the correct way to access question
  get question() {
    // In SurveyQuestionElementBase, the question is available as this.questionBase
    // OR as this.props.question
    return this.questionBase || this.props.question;
  }

  handleChange = (e) => {
    this.question.value = e.target.value;
  };

  renderElement() {
    const q = this.question;
    // FIX: Check if question exists
    if (!q) {
      return <div>Loading...</div>;
    }

    const value = q.value || "";

    return (
      <input
        type="url"
        value={value}
        onChange={this.handleChange}
        placeholder={q.placeholder}
        disabled={q.isReadOnly}
        required={q.isRequired}
        style={{
          width: "100%",
          padding: "8px 12px",
          border: "1px solid #ccc",
          borderRadius: "4px",
          fontSize: "14px",
        }}
      />
    );
  }
}

/* =========================================================
   REGISTRATION
========================================================= */
export function registerVideoURLQuestion() {
  // Register with Serializer
  Serializer.addClass(
    QUESTION_TYPE,
    [
      {
        name: "placeholder",
        category: "general",
        default: "Enter video URL",
      },
    ],
    () => new QuestionVideoURLModel(""),
    "text"
  );

  // Register with QuestionFactory
  QuestionFactory.Instance.registerQuestion(
    QUESTION_TYPE,
    (name) => new QuestionVideoURLModel(name)
  );

  // Register React component
  ReactQuestionFactory.Instance.registerQuestion(QUESTION_TYPE, (props) => (
    <SurveyQuestionVideoURL {...props} />
  ));
}

export default QuestionVideoURLModel;
